<template>
  <div class="card">
    <div class="card-body">
      <div>
        <a-page-header :title="$t('menu.preinscription')">
          <template slot="extra"> </template>
          <a-row type="flex">
            <a-statistic
              :title="$t('liste.total')"
              :value="filtredTable.length"
            />
            <a-statistic
              :title="$t('liste.filles')"
              prefix="%"
              :value="countFille"
              :style="{
                margin: '0 32px',
              }"
            />
            <a-statistic
              :title="$t('liste.garcons')"
              prefix="%"
              :value="countGarcon"
            />
          </a-row>
        </a-page-header>
        <div></div>
        <div>
          <a-table
            @change="tableChanged"
            :loading="tableLeading"
            :pagination="true"
            :data-source="data"
            :columns="columns"
            :rowKey="'_id'"
          >
            <template slot="specialty" slot-scope="text, record">
              {{ record.specialty }}
            </template>
            <template slot="duration" slot-scope="text, record">
              {{ record.duration }}
            </template>
            <template slot="fullName" slot-scope="text, record">
              {{ record.firstName + " " + record.lastName }}
            </template>
            <template slot="expandedRowRender" slot-scope="record">
              <p>
                {{ $t("preinscription.message") }}: {{ record.notes }}
              </p>
            </template>
            <div
              slot="filterDropdown"
              slot-scope="{
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
                column,
              }"
              style="padding: 8px"
            >
              <a-input
                v-ant-ref="(c) => (searchInput = c)"
                :placeholder="`${$t('recette.chercher')} ${column.title}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block"
                @change="
                  (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
                "
                @pressEnter="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
                >{{ $t("recette.chercher") }}</a-button
              >
              <a-button
                size="small"
                style="width: 90px"
                @click="() => handleReset(clearFilters)"
                >{{ $t("action.reinitialiser") }}</a-button
              >
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template
              slot="customRender"
              slot-scope="text, record, index, column"
            >
              <span v-if="searchText && searchedColumn === column.dataIndex">
                <template
                  v-for="(fragment, i) in text
                    .toString()
                    .split(
                      new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                    )"
                >
                  <mark
                    v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                    :key="i"
                    class="highlight"
                    >{{ fragment }}</mark
                  >
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>{{ text }}</template>
            </template>
            <template slot="delete" slot-scope="text, record">
              <a-button-group>
                <a-popconfirm
                  :title="$t('inscription.sureToInscri')"
                  @confirm="() => onInscri(record)"
                >
                  <a-button type="primary" size="small" icon="user">
                    {{ $t("inscription.inscription") }}
                  </a-button>
                </a-popconfirm>
                <a-popconfirm
                  :title="$t('all.sureToCancelAlert')"
                  @confirm="() => onDelete(record)"
                >
                  <a-button type="danger" size="small" icon="delete">
                    {{ $t("action.supprimer") }}
                  </a-button>
                </a-popconfirm>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import eventsLogger from "@/services/eventsLogger";
import { mapState } from "vuex";
import { notification } from "ant-design-vue";
import _ from "lodash";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

function readbleDate(dateString) {
  const date = new Date(dateString);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = date.getFullYear();
  return mm + "/" + dd + "/" + yyyy;
}
function getStudents(student) {
    student.BirthDate = readbleDate(student.BirthDate);
    student.createdAt = readbleDate(student.createdAt);
    student.fullname = student.firstName + " " + student.lastName;
  return student;
}

export default {
  created() {
    eventsLogger.addEvent("/api/log", { studen: "changed", by: "a user" });
    this.currentYear = this.settings.schoolarYears.filter(
      (sc) => sc._id == this.settings.activeSchoolarYear
    )[0].name;
    this.activeBuilding = this.settings.image.filter(
      (building) => building.dbName == this.settings.activeBuilding
    )[0];
    this.tableLeading = true;

    apiClient.get("/preinscription/").then((res) => {
      if (res.data && res.data.length > 0) {
      this.data = res.data.map((item) => getStudents(item));
      this.cacheData = cloneDeep(this.data);
      this.filtredTable = cloneDeep(this.data);
      this.preinscriptionData = cloneDeep(this.data);        
      }else{
        this.$message.warning(this.$t("warning.noPreinscription"));
      }
        this.tableLeading = false;

    }).catch((e) => {
      this.$message.warning(this.$t("warning.connectionProblem"));
    });
  },
  data() {
    return {
      componentKey: 0,
      disabledSP: false,
      activeBuilding: {},
      filtredTable: [],
      tableLeading: true,
      reductions: false,
      newStudentForm: this.$form.createForm(this),
      newStudent: {
        birthDate: null,
        gender: null,
        classRoom: null,
        parent: null,
      },
      newParent: false,
      addNewParent: false,
      parentsList: [],
      parentsCount: 0,
      preinscriptionData: [],
      activeStudent: {},
      attestationPresenceBirthdate: "",
      activeStudentlist: [],
      editingKey: "",
      visibleParentFile: false,
      visibleAttestationPresence: false,
      data: [],
      cacheData: null,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      targetKeys: [],
      currentYear: "",
      value: 1,
      value1: 1,
      loadingData: false,
      visibleData: false,
      columns: [
        {
          title: this.$t("preinscription.fullName"),
          dataIndex: "fullName",
          key: "fullName",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "fullName",
          },
          onFilter: (value, record) =>
            record.firstName.toLowerCase().includes(value.toLowerCase()) ||
            record.lastName.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("specialty.name"),  
          dataIndex: "specialty",
          key: "specialty",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "specialty",
          },
          onFilter: (value, record) => (record.specialty).toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("formation_durations.name"),
          dataIndex: "duration",
          key: "duration",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "duration",
          },
          onFilter: (value, record) => (record.duration).toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("preinscription.phone"),
          dataIndex: "phone",
          key: "phone",
          scopedSlots: {
            customRender: "phone",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter:(value,record)=>record.phone.toString().toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: this.$t("preinscription.email"),
          dataIndex: "email",
          key: "email",
          scopedSlots: {
            customRender: "email",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter:(value,record)=>record.email.toString().toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: this.$t("preinscription.createdAt"),
          dataIndex: "createdAt",
          key: "createdAt",
          scopedSlots: {
            customRender: "createdAt",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter:(value,record)=>readbleDate(record.createdAt).toString().toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: this.$t("liste.inscriSupprimer"),
          dataIndex: "delete",
          scopedSlots: { customRender: "delete" },
          fixed: "right",
        },        
      ],
    };
  },
  computed: {
    ...mapState(["settings"]),
    countGarcon: function () {
      return (
        parseFloat(
          (
            (this.filtredTable.reduce(
              (a, v) => (v.gender === "male" ? a + 1 : a),
              0
            ) *
              100) /
            this.filtredTable.length
          ).toFixed(1)
        ) || 0
      );
    },
    countFille: function () {
      return (
        parseFloat(
          (
            (this.filtredTable.reduce(
              (a, v) => (v.gender === "female" ? a + 1 : a),
              0
            ) *
              100) /
            this.filtredTable.length
          ).toFixed(1)
        ) || 0
      );
    },
  },
  methods: {
    moment,
    debounceField: _.debounce(function (e) {
      let field = e.target.id;
      this.newStudentForm.setFieldsValue({
        [field]: e.target.value,
      });
      this.newStudentForm.validateFields([`${field}`]);
    }, 50),

    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf("day");
    },
    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
    },
    triggerAddNewParent() {
      this.disabledSP = !this.disabledSP;
      this.newParent = !this.newParent;
    },
    handleNewStudentParentOnChange(value) {
      this.newStudent.parent = value;
    },
    handleNewStudentDateOnChange(value) {
      this.newStudent.birthDate = value;
    },
    handleNewStudentClassRoomOnChange(value) {
      this.newStudent.classRoom = value;
    },
    handleBlur() {},
    handleFocus() {},
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(value, id, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(id) {
      const newData = [...this.data];
      const target = newData.filter((item) => id === item.id)[0];
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.data = newData;
        this.cacheData = this.data;
      }
    },

    async onInscri(record) {
      const student = this.data.find((s) => s._id == record._id);
      apiClient.post(`/preinscription/add`, {
        students: [student],
      }).then(({data}) => {
        const successList = data.ids
        this.data = this.data.filter((s) => !successList.includes(s._id));
        this.filtredTable = this.filtredTable.filter((s) => !successList.includes(s._id));
        this.preinscriptionData = this.preinscriptionData.filter((s) => !successList.includes(s._id));
        this.$message.success(this.$t("inscription.inscriptionAjoutee"));
      }).catch((e) => {
        this.$message.warning(this.$t("inscription.inscriptionEchoue"));
      });
    },
    onDelete(record) {
      const student = record;
      apiClient.delete(`/preinscription/${student._id}`).then((res) => {
        this.$message.success(this.$t("success.eleveSupprime"));
        this.data = this.data.filter((s) => s._id != record._id);
        this.filtredTable = this.filtredTable.filter((s) => s._id != record._id);
        this.preinscriptionData = this.preinscriptionData.filter((s) => s._id != record._id);
      }).catch((e) => {
        this.$message.warning(this.$t("error.suppressionEchoue"));
      });
    },

    handleCancelModalAdd(e) {
      this.visibleData = false;
      this.addNewParent = false;
    },
    handleCancelModalParent(e) {
      this.visibleParentFile = false;
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    handleChangeTransfer(targetKeys, direction, moveKeys) {
      this.targetKeys = targetKeys;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    showModal() {
      this.visibleData = true;
      this.newStudentForm.resetFields();
    },
    onChange(e) {
      this.newStudent.gender = e.target.value;
    },
    onChangeParent(e) {},
    openNotificationWithIcon(type, msg, desc) {
      notification[type]({
        message: msg,
        description: desc,
      });
    },
  },
};
</script>
<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.editable-row-operations a {
  margin-right: 8px;
}
.switch {
  float: right;
  margin-right: 15px;
}
.bottom {
  margin-top: 7px;
}
label {
  width: 300px;
  line-height: 26px;
  margin-bottom: 20px;
}

a-input {
  height: 25px;
  width: 50%;
  margin-left: 50px;
}
.span {
  /* display: flex;  */
  flex-direction: row;
}
.space {
  margin-left: 200px;
}
.inp {
  margin-left: 0px;
}
.clearfix {
  float: right;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
